import React from 'react'
import { findDOMNode } from 'react-dom'
import moment from 'moment'
import numeral from 'numeral'
import _ from 'underscore'
import dynamics from 'dynamics.js'
import AutoComplete from '../components/react-autocomplete'
import NumericTextBox from '../components/react-numerictextbox'

export default class FutureDMAWidget extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			savedLayout : props.savedLayout || {},

			symbol : '',
			quote : {},
			instrument : {},

			orderType : 'LIMIT',
			accounts : [],
			sendingOrder : false,
		}
	}

	componentWillUnmount() {
    if (this._px_socket) this._px_socket.close()
		this._px_socket = undefined
  }

	componentDidMount() {
		let self = this
    //layout
    if (this.props.onResize)
      this.props.onResize(660,150)

		var orderType_datasrc = [
								{ text: 'LIMIT', value: 'LIMIT' },
								{ text: 'MKT', value: 'MARKET' },
							  ];

		var timeinforce_datasrc = [
								{ text: 'DAY', value: 'DAY' },
								{ text: 'IOC', value: 'IMMEDIATE_OR_CANCEL' },
								{ text: 'FOK', value: 'FILL_OR_KILL' },
							  ];
		var timeinforce_MKT_datasrc = [
								{ text: 'DAY', value: 'DAY' },
							  ];

    	$(this.refs.optOrderType).kendoDropDownList({
	        dataSource: orderType_datasrc,
	        dataTextField: "text",
	        dataValueField: "value",
	        index: 0,
			change: function(e) {
				var value = this.value();

				var optTimeInForce = $(self.refs.optTimeInForce).data("kendoDropDownList");
				if (value == 'MARKET') {
					optTimeInForce.setDataSource(timeinforce_MKT_datasrc);
					optTimeInForce.value('DAY');
					self.refs.txtLimitPrice.setValue('');
					self.refs.txtMaxFloor.setValue('');
				} else {
					optTimeInForce.setDataSource(timeinforce_datasrc);
					optTimeInForce.value('DAY');
				}

				self.setState({
					orderType : value
				})
			}
	    });
    	$(this.refs.optTimeInForce).kendoDropDownList({
	        dataSource: timeinforce_datasrc,
	        dataTextField: "text",
	        dataValueField: "value",
	        index: 0
	    });



//get a list of books to populate the allocations dropdown
			api('/fund', {
				method: 'GET'
			})
			.then((res) => {
				let allBooks = _.reduce(res, (r, next) => _.union(r, next.books), [])
				console.log('books',allBooks)
				if (Array.isArray(allBooks) ==false) return
					this.setState({
						books : allBooks,
						selectedBook : _.find(allBooks, { book_name : this.props.book }) || allBooks[0]
					}, () => {
							$(this.refs.optBook).data("kendoDropDownList")
								.setDataSource(this.state.books);
							$(this.refs.optBook).data("kendoDropDownList")
								.value(this.state.selectedBook.book_id);
					});
			})

			$(this.refs.optBook).kendoDropDownList({
				dataSource: this.state.books,
				dataTextField: "book_name",
				dataValueField: "book_id",
					index: 0,
					select: function(e) {
						var bookId = +(this.value());
						self.setState({
							selectedBook : _.find(self.state.books, { book_id : bookId })
						})
					},
			});

//Get a list of tags for allocations
			api('/fund/tag', {
				method: 'GET'
			})
			.then((res) => {
				console.log('tags',res)
				if (Array.isArray(res) == false) return

					this.setState({
						tags : res,
						selectedTag : _.find(res, { tag : this.props.tag }) ||  res[0]
					}, () => {
							$(this.refs.optTag).data("kendoDropDownList")
								.setDataSource(this.state.tags);
							$(this.refs.optTag).data("kendoDropDownList")
								.value(this.state.selectedTag.tag_id);
					});
			})

			$(this.refs.optTag).kendoDropDownList({
				dataSource: this.state.tags,
				dataTextField: "tag",
				dataValueField: "tag_id",
					index: 0,
					select: function(e) {
						var tagId = +(this.value());
						self.setState({
							selectedTag : _.find(self.state.tags, { tag_id : tagId })
						})
					},
			});

    	$(this.refs.optAccount).kendoDropDownList({
	        dataSource: this.state.accounts,
	        dataTextField: "account",
	        dataValueField: "account_id",
	        index: 0,
    			select: function(e) {
    				var accountId = +(this.value());
    				self.setState({
    					selectedAccount : _.find(self.state.accounts, { account_id : accountId })
    				})
    			},
  		    // dataBound: () => {
  		    //     $(this.items()).each(function(index, item) {
  		    //         var model = $(this.refs.optAccount).data("kendoDropDownList").dataItem(index);
  		    //         $(item).attr("title", model.Name + " " +
  		    //         					  "MaxSingleOrder: " + model.MaxSingleOrderQty + ", " +
  		    //          					  "GrossDayOrder: " + model.GrossDayOrderQty + ", " +
  		    //         					  "NetDayOrder: " + model.NetDayOrderQty + ", " +
  		    //         					  "MaxPosition: " + model.MaxPositionQty);
  		    //     });
  		    // }
	    });

			setTimeout(() => {
				findDOMNode(this.refs.txtSymbol).focus()
			}, 10)

      //sockets
	    realtime().then( (socket) => {
        this._px_socket = socket

				socket.onclose = (e) => {
					if (e.wasClean != true)
						raiseAlert("CONNECTION LOST: " + e.code + " " + e.reason)
				}
				socket.onjson = (m) => {
					if (!(m.symbol)) return
					if (m.symbol != this.state.symbol) {
						this._px_socket.unsubscribe("pricefeed.Quote.RIC:" + m.symbol)
						return
					}
					Object.assign(this.state.quote, m)
					this.renderQuote(m)
				}

	    	//load from saved state
				let savedSymbol = this.state.savedLayout.symbol || this.props.symbol
	    	if (savedSymbol) {
	    		this.refs.txtSymbol.setValue(savedSymbol);
	    		this.handleSymbolChanged(savedSymbol);
	    	}

				if (this.props.quantity) {
					this.refs.txtQuantity.setValue(this.props.quantity);
				}
      })
	}

	handleSymbolChanged(symbol) {
		if (this.state.symbol)
			this._px_socket.unsubscribe("pricefeed.Quote.RIC:" + this.state.symbol)
		// set immediate to invalid quote events
		this.state.symbol = symbol
		this.state.instrument = {}
		if (this.props.onTitle)
			this.props.onTitle(symbol)
		if (this.state.quote) {
			// clear quote binded boxes
			for (var key in this.state.quote) {
			  $(this.refs.pricefeed).find('.px_' + key).html('');
			  $(this.refs.pricefeed).find('.px_' + key).data('quote', NaN);
			}
			this.state.quote = {}
			// clear all price cells
		  $(this.refs.pricefeed).find('td.bidvol').html('');
		  $(this.refs.pricefeed).find('td.askvol').html('');
		  $(this.refs.pricefeed).find('td.bidpx').html('');
		  $(this.refs.pricefeed).find('td.askpx').html('');
		}
		// clear state
		this.setState({
			symbol : symbol,
			accounts : [],
			selectedAccount : undefined,
			quote : {}, instrument: {},
		}, () => {
			// clear local dropdown first
			var accountLst = $(this.refs.optAccount).data("kendoDropDownList");
			accountLst.setDataSource([{account: 'N/A', account_id: -42}]);
			accountLst.value(-42)

			// Subscribe Reuters
			this._px_socket.subscribe("pricefeed.Quote.RIC:" + symbol)

			// Get Instrument
	    api('/instrument?symbol='+symbol)
	      .then( (res) => {
					console.log(symbol, "INST => ", res)
					if (res.instrument_id && res.product_type) {
						this.saveLayout()
						this.setState({instrument : res}, () => {
							this.updateTitle()

					    api('/account', {
									method: 'POST',
									body : JSON.stringify({instrument_id: res.instrument_id})
								})
					      .then( (res) => {
									console.log('accounts', res)
									if (Array.isArray(res) == false) return

									if (this._px_socket)
										this.setState({
											accounts : res,
											selectedAccount : res[0]
										}, () => {
												$(this.refs.optAccount).data("kendoDropDownList")
													.setDataSource(this.state.accounts);
												$(this.refs.optAccount).data("kendoDropDownList")
													.value(this.state.accounts[0].account_id);
										});
								})
						})
					}
	      }).catch( (e) => {throw e} )

			// Get initial
	    api('/quote?symbol='+symbol)
	      .then( (res) => {
					console.log(symbol, "INITIAL => ", res)
					Object.assign(this.state.quote, res)
					this.renderQuote(res)
					this.updateTitle()
	      }).catch( (e) => {throw e} )
		})
	}

	updateTitle() {
		let description = this.state.quote.description || this.state.instrument.description || ''
		if (!(this.state.instrument.instrument_id))
			description = '<span class="btn-xs status R" title="Instrument Unknown">#REF!</span>' + description

		if (this.props.onTitle) {
			this.props.onTitle(description)
		}
	}

	handlePriceCellClick(e) {
		var val = $(e.target).closest('td').data('quote');

		if (_.isFinite(val)) {
			this.refs.txtLimitPrice.setValue(val);
		}
	}

	renderQuote(quote) {
		for (var key in quote) {
			let n = quote[key]
			if (key == 'bid' || key == 'ask') key += '1'
			if (key == 'bid_size' || key == 'ask_size') key = key.replace('_','1_')
			let v = n
			if (_.isFinite(n)) n = numeral(n).format('0,0[.][0]0000000')
		  $(this.refs.pricefeed).find('.px_' + key).html(n)
		  $(this.refs.pricefeed).find('.px_' + key).data('quote', v)
		}
	}
	formatBondPrice(value) {
		var v = (''+value).split('.')
		if (v.length > 1) {
			v[1] = '0.' + v[1]
			v[1] = '' + ((+ v[1]) / 0.03125)
			v[1] = v[1].replace('.5', '½')
			v[1] = v[1].replace('.75', '¾')
			v[1] = v[1].replace('.25', '¼')
			v[0] = v[0] + '-' + v[1]
		}
		v = v[0]
		return v;
	}

	saveLayout() {
		if (window.updateLayout) {
			if (this.state.symbol)
				window.updateLayout({
					symbol : this.state.symbol,
				})
		}
	}

  render() {
  return (
    <div ref="widget" className="widget">
    		<div ref="pricefeed" className="pricecells">
            <table className="table"><tbody>
            	<tr className="Px">
            		<td style={{  width: '4.5em' }}><span className="daybar"><span className="label">V:</span><span className="value px_volume"></span></span></td>
            	{
            		_.map(_.range(5,0,-1), (i) => {
            			return <td className={ "bidpx px_bid" + i } key={ "bidpx px_bid" + i } style={ (i == 1 ? {borderRight: 'solid 1px white'} : undefined) } onClick={ (e) => this.handlePriceCellClick(e) }></td>
            		})
            	}{
            		_.map(_.range(1,6), (i) => {
            			return <td className={ "askpx px_ask" + i } key={ "askpx px_ask" + i } onClick={ (e) => this.handlePriceCellClick(e) }></td>
            		})
            	}
            		<td style={{  width: '4.5em' }}><span className="daybar"><span className="label">L:</span><span className="value px_last_price"></span></span></td>
            	</tr>
            	<tr className="Vol">
            		<td style={{  width: '4.5em' }}><span className="daybar"><span className="label">L:</span><span className="value px_low"></span></span></td>
            	{
            		_.map(_.range(5,0,-1), (i) => {
            			return <td className={ "bidvol px_bid" + i + "_size" } key={ "bidvol px_bid" + i + "_size" } style={ (i == 1 ? {borderRight: 'solid 1px gray'} : undefined) }></td>
            		})
            	}{
            		_.map(_.range(1,6), (i) => {
            			return <td className={ "askvol px_ask" + i + "_size" } key={ "askvol px_ask" + i + "_size" }></td>
            		})
            	}
            		<td style={{  width: '4.5em' }}><span className="daybar"><span className="label">H:</span><span className="value px_high"></span></span></td>
            	</tr>
            	<tr className="OrdTracker">
            		<td style={{  width: '4.5em' }}><span className="daybar"><span className="label">O:</span><span className="value px_open"></span></span></td>
            	{
            		_.map(_.range(5), (i) => {
            			return <td key={ "bidord" + i }></td>
            		})
            	}{
            		_.map(_.range(4,-1,-1), (i) => {
            			return <td key={ "askord" + i }></td>
            		})
            	}
            		<td style={{  width: '4.5em' }}><span className="daybar"><span className="label">C:</span><span className="value px_close"></span></span></td>
            	</tr>
            </tbody></table>
    		</div>

    		{ (this.state.selectedAccount && this.state.selectedAccount.GrossDayOrderQty ?
          <div ref="compliancebar" className="compliancebar hide" style={{textAlign: 'right'}}>
              <div className="control">
                  <span className="label">Gross Day Limit</span>
                  <span>{ (this.state.selectedAccount.GrossDayOrderQty ? this.state.selectedAccount.GrossDayOrderQty : '') }</span>
              </div>
              <div className="control">
                  <span className="label">Net Day Limit</span>
                  <span>{ (this.state.selectedAccount.NetDayOrderQty ? this.state.selectedAccount.NetDayOrderQty : '') }</span>
              </div>
              <div className="control">
                  <span className="label">Max Position Limit</span>
                  <span>{ (this.state.selectedAccount.MaxPositionQty ? this.state.selectedAccount.MaxPositionQty : '') }</span>
              </div>
          </div> : undefined) }

          <div ref="orderbar" className="orderbar">
              <div className="control">
                  <button className="orderbutton sell" onClick={ () => { this.handleSendOrder("SELL") } }
                  		disabled={ (this.state.sendingOrder ? true : false) }>
                  		SELL
                  	<span className="orderbutton_feedback"/></button>
              </div>
              <div className="control">
                  <span className="label">Symbol</span>
                  <AutoComplete ref="txtSymbol" dataSource={ this.props.futures } forceUpperCase={true}
                  			  dataTextField='symbol' dataValueField='symbol'
                  			  width={ 80 }
                  			  onChange={ (symbol) => this.handleSymbolChanged(symbol) } />
              </div>
              <div className="control">
                  <span className="label">Quantity</span>
                  <NumericTextBox ref="txtQuantity" width={ 90 } decimals={0} format='n0' min={0}/>
              </div>
              <div className="control">
                  <span className="label">Limit Price</span>
                  <NumericTextBox ref="txtLimitPrice" width={ 90 } decimals={9} format='#.##########' step={0.01} min={0}  disabled={ ( this.state.orderType === 'MARKET' ? true : false ) }  />
              </div>
              <div className="control">
                  <span className="label">OrderType</span>
	            <select ref="optOrderType" style={{ width : '7em' }}></select>
              </div>
              <div className="control">
                  <span className="label">Duration</span>
	            <select ref="optTimeInForce" style={{ width : '6em' }}></select>
              </div>
              <div className="control">
                  <span className="label">MaxFloor</span>
                  <NumericTextBox ref="txtMaxFloor" width={ 70 } decimals={0} format='n0' min={0}  disabled={ true || ( this.state.orderType === 'MARKET' ? true : false ) } />
              </div>
              <div className="control">
                  <span className="label">Account</span>
	            <select ref="optAccount" style={{ width : '8.1em' }}></select>
              </div>
              <div className="control">
                  <button className="orderbutton buy" onClick={ () => { this.handleSendOrder("BUY") } }
                  		disabled={ (this.state.sendingOrder ? true : false) }>
                  		BUY
                  	<span className="orderbutton_feedback"/></button>
              </div>
          </div>

					<div ref="allocations" className="orderbar allocation">
							<div className="separator"/>

							<div className="control">
									<span className="label">Book</span>
									<select ref="optBook" style={{ width : '14em' }}></select>
							</div>
              <div className="control">
									<span className="label">Tag</span>
									<select ref="optTag" style={{ width : '9em' }}></select>
              </div>

          </div>

          {  (this.props.allocations ?
            <div ref="allocationbar" className="allocationbar">
            { _.map(this.props.allocations, alloc => {
            			return <div key={ alloc.tag } style={{fontSize:'0.8em'}}><span style={{opacity:0.6,padding: '0 1em'}}>allocation:</span><span style={{fontStyle:'italic'}}>{ alloc.tag }</span></div>
            		})
            }
            </div>
          	: null)
          }
      </div>
    );
  }

	// ORDER ACTIONS =============================================================

	handleSendOrder(side) {
		if (this.state.sendingOrder || !this.state.symbol) return
		if (!this.state.instrument.instrument_id) return

		let errors = []
		let order = {
			//clOrdId      : window.GUID(),
			side            : side,
			security_id_source : '_DEF', 												// avoid instrument lookup
			security_id     : JSON.stringify(Object.assign({},
														_.omit(this.state.instrument, 'definition'),
														_.pick(this.state.instrument.definition,
																	 'exchange_mic', 'expiry_date', 'root_instrument_id', 'multiplier'),
 													// 	_.pick(this.state.quote, 'symbol_root')
													  )
												),
			quantity        : this.refs.txtQuantity.getValue(),

			order_type       : $(this.refs.optOrderType).data("kendoDropDownList").value(),
			limit_price      : this.refs.txtLimitPrice.getValue(),

			timeinforce     : $(this.refs.optTimeInForce).data("kendoDropDownList").value(),
		}

		if (_.isNumber(order.quantity) == false)
			errors.push('Invalid quantity');
		if (order.order_type == 'LIMIT')
			if (_.isNumber(order.limit_price) == false)
				errors.push('Invalid limit price');
		if (order.order_type == 'MARKET')
			delete order.limit_price;
		if (order.order_type == 'STOP')
			delete order.limit_price;

		// Account
		let account = $(this.refs.optAccount).data("kendoDropDownList").value();
		account = _.find(this.state.accounts, { account_id : +(account) });
		if (account) {
			order.account_id = account.account_id;
			order.account = account.account;
			order.market_connector = account.market_connector;

			if (order.market_connector === undefined)
				errors.push('Invalid market connector');
		} else {
			errors.push('Invalid account');
		}


		let book = $(this.refs.optBook).data("kendoDropDownList").value();
		book = _.find(this.state.books, { book_id : +(book) });

		let tag = $(this.refs.optTag).data("kendoDropDownList").value();
		tag = _.find(this.state.tags, { tag_id : +(tag) });

		// TODO: Allocations
		order.allocations = [
			 {
			   "book_name": book.book_name,
			   "tag": tag.tag,
			   "quantity": order.quantity,
			 }
		]

		if (errors.length > 0) {
			raiseAlert(_.reduce(errors, (result, val) => { return result + '\n' + val }, "ERROR: Could not submit order\n "))
			return;
		}

		console.log("SUBMIT ORDER =>", order);
		this.state.sendingOrder = true
		this.setState({
			sendingOrder : true
		})

    api('/order', {
				method: 'POST',
				body : JSON.stringify(order)
			})
      .then( (response) => {
        this.setState({
        	sendingOrder : false
        })

				console.log(response)
				if (!response.order_key && response.detail) {
					raiseAlert(response.detail)
				} else if (response.ok == false && response.errors) {
					// Complaince Fail
					let htmlContent = `
					<div class="alarming">LIMIT BREACH</div>
					<table class='table table-hover'>
					<thead>
						<tr>
							<td>description</td>
							<td>constraint</td>
							<td style="text-align:right;">⇤</td>
							<td style="text-align:right;">value</td>
							<td style="text-align:right;">⇥</td>
						</tr>
					</thead>
					<tbody>
					`
					for (var i = 0; i < response.errors.length; i++) {
						let detail = response.errors[i]
						if (detail.rule_name && detail.constraint_name) {
							detail.constraint_lbound = numeral(detail.constraint_lbound).format('0,0[.][0]0')
							detail.constraint_value = numeral(detail.constraint_value).format('0,0[.][0]0')
							detail.constraint_ubound = numeral(detail.constraint_ubound).format('0,0[.][0]0')
							htmlContent += `<tr title="${detail.text}">
								<td>${detail.rule_name}</td>
								<td>${detail.constraint_name}</td>
								<td style="text-align:right;${detail.text.indexOf('LowerBound breach') == 0 ? 'color: red' : ''}">${detail.constraint_lbound}</td>
								<td style="color: #ff6e00;text-align:right;">${detail.constraint_value}</td>
								<td style="text-align:right;${detail.text.indexOf('UpperBound breach') == 0 ? 'color: red' : ''}">${detail.constraint_ubound}</td>
							</tr>`
						} else {
							htmlContent += `<tr>
								<td colspan="5">${detail.text}</td>
							</tr>`
						}
					}
					htmlContent += `
					</tbody>
					</table>`

					raiseAlert(htmlContent)
				} else {
                	//Order sent animation feedback effects
									var feedbackDom = $(this.refs.orderbar).find('.orderbutton.' + (side === 'BUY' ? 'buy' : 'sell') + ' .orderbutton_feedback')[0];
									if (feedbackDom) {
										dynamics.stop(feedbackDom);
										dynamics.css(feedbackDom, {
										    translateX: 0,
										    translateY: 0,
										    scale: 1,
										    opacity: 0,
										});
										dynamics.animate(feedbackDom, {
										    opacity: 0.8,
										}, {
										    type: dynamics.spring,
										    frequency: 310,
										    friction: 52,
										    duration: 150,
										    complete: () => {
										        dynamics.animate(feedbackDom, {
										            translateX: (side === 'BUY' ? -250 : 250),
										            translateY: -50,
										            scale: 0.2,
										            opacity: 0.01,
										        }, {
										            type: dynamics.easeIn,
										            friction: 1,
										            duration: 200,
										            complete: () => {
										                dynamics.css(feedbackDom, {
										                    translateX: 0,
										                    translateY: 0,
										                    scale: 1,
										                    opacity: 0,
										                });
										            }
										        })
										    }
										})
									}
				}
			})

	}
}



// WEBPACK FOOTER //
// ./src/widgets/future.jsx